import React from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';

import CartPage from './Cart/CartPage';
import ContactUsPage from './ContactUS/ContactUsPage';
import FindPasswordPage from './FindPassword/FindPasswordPage';
import LoginPage from './Login/LoginPage';
import Main from './Main/Main';
import MyPagePage from './MyPage/MyPagePage';
import OrderPage from './Order/OrderPage';
import ProductDetailPage from './Product/ProductDetailPage';
import ProductListPage from './Product/ProductListPage';
import SearchProductListPage from './Product/SearchProductListPage';
import Footer from './shared/components/Layout/Footer';
import Header from './shared/components/Layout/Header';
import SignUpPage from './SignUp/SignUpPage';
// import Header from "./components/Header/Header";
// import Nav from "./components/Nav/Nav";
// import Login from "./pages/login/Login";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  return (
    <div className="flex min-h-screen">
      <div className="w-full">{children}</div>
    </div>
  );
};

const Router = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Header />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/findpassword" element={<FindPasswordPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/productlist/:id" element={<ProductListPage />} />
          <Route path="/search" element={<SearchProductListPage />} />
          <Route path="/productdetail/:id" element={<ProductDetailPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/mypage/*" element={<MyPagePage />} />
        </Routes>
        <Footer />
      </Layout>
    </BrowserRouter>
  );
};

export default Router;
